import TagManager from 'react-gtm-module';

import { GTM_ID } from '^configs/environments';
import IGTMEvent from '^types/gtm/IGTMEvent';
import GTMEventCategory from '^enums/gtm/GTMEventCategory';
import IGTMDimension from '^types/gtm/IGTMDimension';
import TGTMDataLayer from '^types/gtm/TGTMDataLayer';
import ApplicationConfig from '^services/ApplicationConfig';

enum Event {
  Default = 'GAEvent',
  CustomDimensionsUpdate = 'CustomDimensionsUpdate',
  Pageview = 'pageview',
}

const { utmSource, utmMedium, utmCampaign, trackingClickId, trackingId } = window.xprops;
const APPLICATION_NAME = 'PriceLists';
const defaultDimension: IGTMDimension = {
  applicationName: APPLICATION_NAME,
  originalLocation: window.location.href,
  brand: ApplicationConfig.brand,
  modelCode: ApplicationConfig.modelCode,
  businessType: ApplicationConfig.businessType,
  utmSource,
  utmMedium,
  utmCampaign,
  trackingClickId,
  trackingId,
};

class GTMHelper {
  private currentDimension: IGTMDimension = defaultDimension;

  private emitGTMEvent = (dataLayer: Partial<TGTMDataLayer>): void => {
    TagManager.dataLayer({
      dataLayer,
    });
  };

  public init = (): void => {
    if (!GTM_ID) {
      return;
    }

    TagManager.initialize({
      gtmId: GTM_ID,
    });

    this.updateDimension(defaultDimension);
  };

  public updateDimension = (dimension: Partial<IGTMDimension>): void => {
    this.currentDimension = {
      ...this.currentDimension,
      ...dimension,
    };

    this.emitGTMEvent({
      event: Event.CustomDimensionsUpdate,
      ...this.currentDimension,
    });
  };

  public emitEvent = (category: GTMEventCategory, action: string, label: string = ''): void => {
    const dataLayer: IGTMEvent = {
      event: Event.Default,
      eventLabel: label,
      eventCategory: category,
      eventAction: action,
      ...this.currentDimension,
    };

    this.emitGTMEvent(dataLayer);
  };

  public emitPageView = (path: string): void => {
    this.emitGTMEvent({
      event: Event.Pageview,
      VirtualPageviewPath: path,
      ...this.currentDimension,
    });
  };
}

export default new GTMHelper();
